import { createAsyncThunk } from "@reduxjs/toolkit";
import { parseApiError } from "../../utils/api_error";
import { getCompanyProfile } from "../../services/auth";

// Add to cart
export const companyProfile = createAsyncThunk(
  "system/getCompanyProfile",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getCompanyProfile();
      return res; // updated cart from backend
    } catch (err) {
      const message = parseApiError(err);
      return rejectWithValue(message);
    }
  },
);
